module.exports = __webpack_public_path__ + "static/media/eps-icon.6c278def.svg";